import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Henkilöt',
    financial_metrics: 'Taloudelliset mittarit',
    onboarding_and_quality: 'Käyttöönotto ja laatu',
    subscriptions: 'Nykyiset tilaukset',
    payments: 'Maksut',
    last_invoices: 'Viimeisimmät laskut',
  },
  fields: {
    google_profile: 'Google-profiili',
    owner_name: 'Omistajan nimi',
    owner_phone_number: 'Omistajan puhelin',
    company_phone_number: 'Ravintolan puhelin',
    address: 'Osoite',
    onboarding_manager: 'Käyttöönottopäällikkö',
    sales_manager: 'Myyntipäällikkö',
    last_30_days_sales: 'Viimeisen 30 päivän liikevaihto',
    lifetime_sales: 'Kokonaisliikevaihto',
    monthly_sales_other_platforms: 'Toimitussovellusten myynti',
    delivery_app_sales_at_go_live: 'Toimitussovelluksen myynti käyttöönottopäivänä',
    last_payout: 'Viimeisin tilitys',
    potential_tier: 'Potentiaalipisteet',
    current_tier: 'IST-pisteet',
    signed_at: 'Allekirjoituspäivä',
    live_from: 'Julkaisupäivä',
    onboarding_quality_score: 'Julkaisun laatupisteet',
    is_google_business_available: 'Google Business käytössä',
    is_smart_pricing_configured: 'Halvemmat hinnat kuin Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Mainoslehtinen lähetetty',
    is_menu_fully_configured: 'Kaikki ruokalistan tuotteet saatavilla',
    has_offers_on_competitor_platforms:
      'Onko ravintolalla tarjouksia käynnissä Woltissa, Uberissa tai Lieferandossa (ilmaista toimitusta lukuun ottamatta)?',
    is_instagram_story_shared: 'Instagram-tarina jaettu omistajan kanssa',
    is_order_system_connected_to_website:
      'Foodamigos-verkkosivu yhdistetty TAI ravintolan omalle verkkosivulle lisätty tilauspainike',
    delivery_mode: 'Kuljettajat',
    has_storefront: '{{provider}}-verkkosivu',
    screening_date: 'Seulontapäivä',
  },
  setup_fee: {
    title: 'Käyttöönottomaksu',
    status: {
      [InvoiceStatus.Paid]: 'Maksettu',
      [InvoiceStatus.Pending]: 'Odottaa',
      [InvoiceStatus.Processing]: 'Käsittelyssä',
      [InvoiceStatus.Refunded]: 'Hyvitetty',
      [InvoiceStatus.PartiallyRefunded]: 'Osittain hyvitetty',
      [InvoiceStatus.Failed]: 'Epäonnistui',
    },
  },
  labels: {
    yes: 'Kyllä',
    no: 'Ei',
    month: 'Kuukausi',
    recorded_on: 'Tallennettu {{date}}',
  },
  delivery_app_sales_correction: {
    title: 'Korjaa toimitussovelluksen myynti käyttöönotossa',
    description:
      'Korjaa tässä vain kirjoitusvirheen. Tämä on kuukausittainen luku, jonka käyttöönotto tallensi ravintolan avautuessa, ja raportointi vertaa sitä myynnin lukuun. Muutos kirjataan lokiin.',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Aktiivinen',
    [CompanyOperationalStatus.Paused]: 'Keskeytetty',
    [CompanyOperationalStatus.Suspended]: 'Menetetty',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Vakio',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Kuukausittain',
    [SubscriptionTerm.Annual]: 'Vuosittain',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Omat kuljettajat',
    [DeliveryMode.External]: '{{provider}}-kuljettajat',
  },
  buttons: {
    view_details: 'Näytä tiedot',
    open: 'Avoin',
    correct: 'Korjaa',
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    delivery_app_sales_corrected: 'Toimitussovelluksen myynti korjattu',
    failed_to_correct_delivery_app_sales: 'Toimitussovelluksen myynnin korjaaminen epäonnistui',
  },
};
